module.exports = __webpack_public_path__ + "assets/img/326101.0ba73098.png";